import { Box, Button, Checkbox, FormControlLabel, FormGroup, Grid2, IconButton, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import React, { useEffect, useMemo, useState } from "react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import CloseIcon from '@mui/icons-material/Close';
import TokenError from "../tokenError";
import config from '../../config/config.js';
import CommonGeofence from "../geofence/CommonGeofence.jsx";
import { Label } from "flowbite-react";
import dayjs from 'dayjs';
import { GoogleMap, Polygon, useJsApiLoader } from "@react-google-maps/api";
import constants from '../../constant.js';
import { useNavigate } from "react-router-dom";
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";
import CreateIcon from '@mui/icons-material/Create';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import utc from 'dayjs/plugin/utc';

const LIBRARIES = ["maps", "drawing", "places", "geometry"];
dayjs.extend(utc);

const CustomZone = () => {
    const token = localStorage.getItem('token');
    const date = dayjs().utc();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [zoneTypeFilter, setZoneTypeFilter] = useState('');
    const [weekDaysData, setWeekDaysData] = useState('');
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [startTime, setStartTime] = useState(date);
    const [endTime, setEndTime] = useState(date);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [city, setCity] = useState(cities[0]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [CustomZoneData, setCustomZoneData] = useState([]);
    const customZoneTypeConst = constants.CustomZoneTypeConst;
    const [zoneName, setZoneName] = useState('');
    const [zoneType, setZoneType] = useState('');
    const [rate, setRate] = useState('');
    const cityGeo = city ? city.geofence[0] : '';
    const [customGeofence, setCustomGeofence] = useState(cityGeo);
    const [customZoneId, setCustomZoneId] = useState(-1);
    const [activeStatus, setActivestatus] = useState(1);
    const [callDeleteAPI, setCallDeleteAPI] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [polyPath, setPolyPath] = useState([]);
    const [mapInstance, setMapInstance] = useState(null);
    const [bound, setBound] = useState(false);
    const [geofenceType, setGeofenceType] = useState('');
    const [geofencePickup, setGeofencePickup] = useState([]);
    const [geofenceDrop, setGeofenceDrop] = useState([]);
    const [customGeofence2, setCustomGeofence2] = useState([]);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [vehicleClient, setVehicleClient] = useState('');
    const [vehicleId, setVehicleId] = useState('');
    const [driverCut, setDriverCut] = useState('');
    const [selectedGrid, setSelectedGrid] = useState(null);
    const [nullGeofence, setNullGeofence] = useState(false); //when polygon is deleted.
    const navigate = useNavigate();

    useEffect(() => {
        console.log("Geofence effect triggered with:", { 
            customGeofence: customGeofence, 
            customGeofence2: customGeofence2,
            customGeofenceLength: customGeofence?.length || 0,
            customGeofence2Length: customGeofence2?.length || 0
        });
        
        if (mapInstance && ((customGeofence && customGeofence.length > 0) || (customGeofence2 && customGeofence2.length > 0))) {
            const bounds = new window.google.maps.LatLngBounds();
            let boundsExtended = false;
            
            if (customGeofence && customGeofence.length > 0) {
                console.log("Adding points from customGeofence to bounds");
                customGeofence.forEach((point) => {
                    if (point && point.x !== undefined && point.y !== undefined) {
                        bounds.extend({ lat: Number(point.x), lng: Number(point.y) });
                        boundsExtended = true;
                    }
                });
            }
            
            if (customGeofence2 && customGeofence2.length > 0) {
                console.log("Adding points from customGeofence2 to bounds");
                customGeofence2.forEach((point) => {
                    if (point && point.x !== undefined && point.y !== undefined) {
                        bounds.extend({ lat: Number(point.x), lng: Number(point.y) });
                        boundsExtended = true;
                    }
                });
            }
            
            if (boundsExtended) {
                console.log("Fitting bounds to include all geofences");
                mapInstance.fitBounds(bounds);
            }
        }
    }, [customGeofence, customGeofence2, mapInstance]);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
        setCity(city);
        const geoo = city ? city.geofence[0] : '';
        setCustomGeofence(geoo);
    }

    const handleZoneTypeChange = (e) => {
        setZoneTypeFilter(e);
    }

    const handleUpdatePolygon = (polygonPath) => {
        // console.log("Updated polygon path received from child:", polygonPath);
        
        // Ensure polygonPath is an array and has valid entries
        if (!Array.isArray(polygonPath) || polygonPath.length === 0) {
            console.error("Invalid polygon path:", polygonPath);
            if(geofenceType === 'pickup'){
                setGeofencePickup([]);
                setNullGeofence(true);
                setCustomGeofence([]);
                setMessage('Please draw pickup polygon.');
            }
            else if(geofenceType === 'drop'){
                setGeofenceDrop([]);
                setNullGeofence(true);
                setCustomGeofence2([]);
                setMessage('Please draw drop polygon.');
            }
            else{
                setPolyPath([]);
                console.log('hereerere');
                setMessage('Please draw polygon.');
            }
            showSnackbar(true);
            // setPolyPath([]);
            return;
        }
        else {
            // Convert to format expected by CommonGeofence (x, y)
            const mainGeofence = polygonPath.map((point) => ({
                x: Number(point.lat),
                y: Number(point.lng),
            }));
            setNullGeofence(false);

            // console.log("Converted geofence format:", mainGeofence);
        
            if (geofenceType === 'pickup') {
                console.log('Setting pickup geofence');
                setGeofencePickup(mainGeofence);
                setCustomGeofence(mainGeofence);
            } else if (geofenceType === 'drop') {
                console.log('Setting drop geofence');
                setGeofenceDrop(mainGeofence);
                setCustomGeofence(mainGeofence);
            } else {
                console.log('Setting poly path');
                setPolyPath(mainGeofence);
            }

            setMessage('Polygon saved.');
            showSnackbar(true);
        }
    };

    const fetchCustomZoneData = async() => {
        try {
            const url = serverUrl + '/custom/fetch_custom_zones';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setCustomZoneData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchVehicleClient = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/vehicle/get_client_vehicles';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Filter active vehicles
                const activeVehicles = response.data.filter(vehicle => vehicle.is_active === 1);
                // console.log('response.data[0] = ', activeVehicles[0].vehicle_type)
                setVehicleClient(activeVehicles);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchCustomZoneData();
        setCustomGeofence2([]);
        fetchVehicleClient();
    }, [cityFilter]);

    const handleGridClick = (data) => {
        const city =  cities.find((cityObj) => cityObj.city_id === data.city_id)
        const geo = data.geofence ? data.geofence[0] : [];
        setCustomGeofence(geo);
        // Safely access array with proper null/undefined checks
        const geo2 = (data.geofence_2 && Array.isArray(data.geofence_2) && data.geofence_2.length > 0) ? 
                      data.geofence_2[0] : 
                      [];
        setCustomGeofence2(geo2);
        setSelectedGrid(data);
    }

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setOpenEditModal(false);
        setCustomZoneId(1);
        setZoneName('');
        setZoneType('');
        setSelectedGrid(null);
        setRate('');
        setActivestatus(1);
        setCustomZoneId(-1);
        setGeofenceType('');
        setVehicleId('');
        setDriverCut('');
        setGeofencePickup([]);
        setGeofenceDrop([]);
        setNullGeofence(false);
        setWeekDaysData('');
        setStartDate(dayjs());
        setEndDate(null);
        setStartTime(null);
        setEndTime(null);
    }

    const handleOpenEdit = (row) =>{
        setCustomZoneId(row.zone_id);
        setZoneName(row.name);
        setZoneType(row.type);
        if(row.rate) setRate(row.rate);
        setOpenEditModal(true);
        setSelectedGrid(row);
        setOpenAddModal(false);
        // 
        // const paths = 
        // setCustomGeofence(row.geofence ? row.geofence[0] : []);
        setActivestatus(1);
        setGeofencePickup(row.geofence ? row.geofence[0] : []);
        setGeofenceDrop(row.geofence_2 ? row.geofence_2[0] : []);
        if(row.type==4){
            setGeofenceType('pickup');
        }
        setVehicleId(row.vehicle_id);
        setDriverCut(row.driver_cut);
        setNullGeofence(false);
        setStartDate(dayjs(row.start_date));
        setEndDate(dayjs(row.end_date));

        // Explicitly parse `start_time` and `end_time` in "HH:mm:ss" format
        // setStartTime(dayjs.utc(row.start_time, "HH:mm:ss").local());
        // setEndTime(dayjs.utc(row.end_time, "HH:mm:ss").local());

        setStartTime(dayjs(row.start_time, "HH:mm:ss").add(utcOffset, 'minute'));
        setEndTime(dayjs(row.end_time, "HH:mm:ss").add(utcOffset, 'minute'));
        setWeekDaysData(row.week_days);
    }
    const handleDeleteFunc = (row) => {
        setCustomZoneId(row.zone_id);
        setActivestatus(0);
        setZoneName(row.name);
        if(row.rate) setRate(row.rate);
        setZoneType(row.type);
        setCustomGeofence(row.geofence ? row.geofence[0] : []);
        setCallDeleteAPI(true);
        setVehicleId(row.vehicle_id);
        setDriverCut(row.driver_cut);
        setGeofencePickup(row.geofence ? row.geofence[0] : []);
        setGeofenceDrop(row.geofence_2 ? row.geofence_2[0] : []);
        if(row.type==4){
            setGeofenceType('pickup');
        }
        setNullGeofence(false);
    }

    const handleClose=()=>{
        setOpenEditModal(false);
        setOpenAddModal(false);
        const geof = cities.find(city => city.city_id === cityFilter)
        // console.log('geof====', geof.geofence[0]);
        setCustomGeofence(geof.geofence[0])
        setCustomGeofence2([])
        setSelectedGrid(null);
    }

    useEffect(() => {
        if(callDeleteAPI === true) {
            saveData();
            setCallDeleteAPI(false);
        }
    }, [callDeleteAPI])

    const saveData = async() =>{
        console.log('customGeofence', customGeofence);
        console.log('polyPath', polyPath);
        if(zoneType!=4) {
            setGeofenceType('');
        }
        if(zoneType==4){
            if(driverCut>rate){
                setMessage('Driver cut cannot be greater than charge.');
                showSnackbar(true);
                return;
            }
        }
        // console.log('geofencePickup', geofencePickup);
        // console.log('geofenceDrop', geofenceDrop);
        const geo = customGeofence.map((point) => ({
            lat: point.x ?  Number(point.x) : point.lat, // Convert x to lat
            lng: point.y ?  Number(point.y) : point.lng // Convert y to lng
        }))
        console.log('geo = ', geo)
        const polyypath = polyPath.map((point) => ({
            lat: point.x ?  Number(point.x) : point.lat, // Convert x to lat
            lng: point.y ?  Number(point.y) : point.lng // Convert y to lng
        }))
        // console.log('polypath = ', polyypath)
        const geoPickup = geofencePickup.map((point) => ({
            lat: point.x ?  Number(point.x) : point.lat, // Convert x to lat
            lng: point.y ?  Number(point.y) : point.lng // Convert y to lng
        }))
        const geoDrop = geofenceDrop.map((point) => ({
            lat: point.x ?  Number(point.x) : point.lat, // Convert x to lat
            lng: point.y ?  Number(point.y) : point.lng // Convert y to lng
        }))

        if(zoneType==4){
            if(geoDrop.length==0){
                setMessage('Please draw drop geofence.');
                showSnackbar(true);
                return;
            }
            if(geoPickup.length==0){
                setMessage('Please draw pickup geofence.');
                showSnackbar(true);
                return;
            }
        }

        console.log('nullGeofence', nullGeofence);
        console.log('geofenceType', geofenceType);
        console.log('zoneType', zoneType);
        if(nullGeofence && geofenceType === 'pickup' && zoneType==4){
            setMessage('Please draw pickup polygon.');
            showSnackbar(true);
            return;
        }
        if(nullGeofence && geofenceType === 'drop' && zoneType==4){
            setMessage('Please draw drop polygon.');
            showSnackbar(true);
            return;
        }
        // else{
        //     console.log('poly path = ', polyypath)
        //     if(polyypath.length==0){
        //         setMessage('Please draw polygon.');
        //         showSnackbar(true);
        //         return;
        //     }
        // }
        // if(nullGeofence){
        //     setMessage('Please draw a polygon.');
        //     showSnackbar(true);
        //     return;
        // }
        const formattedStartTime = startTime ? startTime.format("HH:mm:ss") : null; // Ensure 24-hour format
        const formattedEndTime = endTime ? endTime.format("HH:mm:ss") : null;
    
        const payload = {
            token: token,
            name: zoneName,
            type: zoneType,
            status: activeStatus,
            city_id: cityFilter,
        }
        if(rate) payload['rate']=rate;
        if(customZoneId!=-1){
            payload.zone_id = customZoneId;
        }
        if(zoneType == 4) {
            payload.geofence = geoPickup ? geoPickup : geo;
            payload.geofence_2 = geoDrop ? geoDrop : geo;
        }
        else{
            payload.geofence = polyypath.length>0 ? polyypath: geo;
        }
        if(vehicleId && zoneType==4) payload['vehicle_id']=vehicleId;
        if(driverCut && zoneType==4) payload['driver_cut']=driverCut;
        if(zoneType==5){
            payload.start_time = formattedStartTime;
            payload.end_time = formattedEndTime;
            payload.start_date = startDate.format('YYYY-MM-DD');
            payload.end_date = endDate.format('YYYY-MM-DD');
            payload.week_days = weekDaysData;
        }
        
        try {
            const url = operationsUrl + '/custom/add_update_custom_zones';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                handleClose();
                fetchCustomZoneData();

            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            // setMessage(error);
        }

        fetchCustomZoneData();
    }
    
    const { isLoaded, loadError } = useGoogleMapsLoader();

    const containerStyle = {
        width: '100%',
        height: '68vh',
      };
    const center = {
        lat: customGeofence ? customGeofence.reduce((sum, point) => sum + point.x, 0) / customGeofence.length : 0,
        lng: customGeofence ? customGeofence.reduce((sum, point) => sum + point.y, 0) / customGeofence.length : 0,
    };

    const onLoad = React.useCallback(function callback(map) {
        setMapInstance(map);
    }, []);
    
    const onUnmount = React.useCallback(function callback(map) {
        setMapInstance(null);
    }, []);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleCheckboxChange = (event) => {
        const value = event.target.value;

        const currentDays = weekDaysData
            ? weekDaysData.split(',').filter(Boolean)
            : [];

        if (event.target.checked) {
            if (!currentDays.includes(value)) {
                setWeekDaysData([...currentDays, value].join(','));
            }
        } else {
            setWeekDaysData(
                currentDays.filter((day) => day !== value).join(',')
            );
        }
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Custom Zone</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Select value={zoneTypeFilter} 
                    onChange={(e) => handleZoneTypeChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: zoneTypeFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select Zone Type</MenuItem>
                        {Object.entries(constants.CustomZoneTypeConst).map(([id, label]) => (
                            <MenuItem key={id} value={id}>
                                {label}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Custom Zone
                    </Button>
                </Grid2>
            </Grid2>

            <Grid2 item container size={12} spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item size={4} sx={{ overflowY:'auto', maxHeight:'70vh'}}>
                    {(CustomZoneData).filter(data => !zoneTypeFilter || data.type == zoneTypeFilter).map((data) => {
                        const type = constants.CustomZoneTypeConst[data.type] || null;
                        return(
                            <Grid2 item sx={{backgroundColor:'#fff', borderRadius:'12px', padding:'4px', marginBottom:'4%', cursor:'pointer', border:selectedGrid?.zone_id === data.zone_id ? '1px solid #000' : '1px solid #E5E5E5'}}
                                key={data.zone_id} onClick={() => handleGridClick(data)}
                                >
                                <Grid2 item container spacing={1.6} sx={{marginBottom:'8px', padding:'12px'}}>
                                    {/* <Typography>{data.name}</Typography> */}
                                    <Typography sx={{color:'#000'}}>Name: <span style={{color:'#83888E'}}>{data.name}</span></Typography>
                                    <Typography sx={{marginLeft:'auto', color:'#000', fontSize:'14px'}}>ID: {data.zone_id}</Typography>
                                </Grid2>

                                <Grid2 sx={{marginBottom:'8px', padding:'12px'}}>
                                    <Typography sx={{color:'#000'}}>Charge: <span style={{color:'#83888E'}}>{data.rate}</span></Typography>
                                    {/* <Typography sx={{marginLeft:'auto', color:'#83888E', fontSize:'14px'}}></Typography> */}
                                </Grid2>

                                <Grid2 sx={{backgroundColor:'#F9F9F9', padding:'8px', margin:'6px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius:'4px'}}>
                                    <Typography sx={{fontSize:'14px', color:'#000', marginRight:'12px'}}>Zone Type : </Typography>
                                    <Typography sx={{fontSize:'14px', justifyContent:'center', color:'#83888E'}}>{type}</Typography>
                                </Grid2>

                                {/* <hr/> */}
                                <hr style={{ marginTop: '16px', marginBottom: '16px', border: 'none', borderTop: '1px solid #ccc' }} />

                                <Grid2 item container spacing={1.6} sx={{marginBottom:'8px'}}>
                                    <Button sx={{border:'1px solid #C71F1F', width:'140px', marginLeft:'8px'}} onClick={() => handleDeleteFunc(data)}>
                                        <Typography sx={{color:'#C71F1F', textTransform:'none'}}>Delete</Typography>
                                    </Button>
                                    <Button variant="contained" sx={{width:'140px', backgroundColor:'#0DBA78'}} 
                                    onClick={() => handleOpenEdit(data)}
                                    >
                                        <Typography sx={{color:'#EFFBF7', textTransform:'none'}}>Edit</Typography>
                                    </Button>
                                </Grid2>
                            </Grid2>
                        )
                    })}
                    
                </Grid2>

                <Grid2 item size={8}>
                    <Grid2 className='mainBox'>
                        {isLoaded ? (
                            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={8} onIdle={()=> { setBound(true)}} onLoad={onLoad} onUnmount={onUnmount}>
                                
                                {city && city.geofence && city.geofence[0].length > 0 && (
                                    <Polygon
                                        paths={customGeofence.map((point) => ({
                                            lat: Number(point.x), // Convert x to lat
                                            lng: Number(point.y)  // Convert y to lng
                                        }))
                                        .filter((point) => !isNaN(point.lat) && !isNaN(point.lng) && isFinite(point.lat) && isFinite(point.lng))
                                    } 
                                        options={{
                                            fillColor: "rgba(255, 0, 0, 0.3)", // Semi-transparent fill color
                                            fillOpacity: 0.4,
                                            strokeColor: "red",
                                            strokeOpacity: 1,
                                            strokeWeight: 2,
                                        }}
                                    />
                                )}
                                {customGeofence2.length > 0 && (
                                    <Polygon
                                        paths={customGeofence2.map((point) => ({
                                            lat: Number(point.x), // Convert x to lat
                                            lng: Number(point.y)  // Convert y to lng
                                        }))
                                        .filter((point) => !isNaN(point.lat) && !isNaN(point.lng) && isFinite(point.lat) && isFinite(point.lng))
                                    } 
                                        options={{
                                            fillColor: "rgba(255, 0, 0, 0.3)", // Semi-transparent fill color
                                            fillOpacity: 0.4,
                                            strokeColor: "red",
                                            strokeOpacity: 1,
                                            strokeWeight: 2,
                                        }}
                                    />
                                )}
                                
                            </GoogleMap>
                            
                        ): (<></>)}
                    </Grid2>
                </Grid2>
            </Grid2>

            {(openAddModal || openEditModal) && (
                <div 
                style={{position: 'fixed',top: 65, right:0, height: '100%',width: '78%',backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,overflowY: 'auto',padding: 20
                }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>

                            <Grid2 item container spacing={2} size={12} sx={{marginLeft:'12px'}}>
                                <Grid2 item size={5} sx={{
                                    backgroundColor:'#fff', 
                                    padding:'12px', 
                                    borderRadius:'12px', 
                                    overflowY:'auto',
                                    maxHeight: '84vh', 
                                    height: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <Typography sx={{color:'#4E545D', fontSize:'24px', fontWeight:500}}>New Custom Zone</Typography>
                                    
                                    <Grid2 item sx={{marginTop:'3%', padding:'4px'}}>
                                        <Label>Zone Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Zone Name" fullWidth variant="outlined" type="text" 
                                            value={zoneName}
                                            onChange={(e) => setZoneName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{marginTop:'3%', padding:'4px'}}>
                                        <Label>Zone Type<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'2%'}}
                                            placeholder="Select Zone Type" select
                                            fullWidth variant="outlined"
                                            value={zoneType}
                                            onChange={(e) => {
                                                setZoneType(e.target.value)
                                                setGeofenceType('')
                                                setGeofencePickup([]);
                                                setGeofenceDrop([]);
                                            }}
                                            InputProps={{
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF',},
                                            }}
                                        >
                                            {Object.entries(constants.CustomZoneTypeConst).map(([id, label]) => (
                                                <MenuItem key={id} value={id}>
                                                    {label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid2>

                                    {zoneType==4 && (
                                        <Grid2 item sx={{marginTop:'3%', padding:'4px'}}>
                                            <Label>Vehicle Type<span style={{ color: 'red' }}>*</span></Label>
                                            <Select sx={{marginTop:'2%'}} fullWidth
                                                value={vehicleId} 
                                                onChange={(e) => setVehicleId( e.target.value)}
                                                style={{ height: '50px', borderRadius: '8px'}}>
                                                {/* <MenuItem value="">Vehicle</MenuItem> */}
                                                {vehicleClient.map((vehicle) => (
                                                    <MenuItem key={vehicle.vehicle_type} value={vehicle.vehicle_id}>
                                                        {vehicle.vehicle_name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid2>
                                    )}
                                    {zoneType==4 && (
                                        <Grid2 item sx={{marginTop:'3%', padding:'4px'}}>
                                            <Label>Driver Cut<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Driver Cut" fullWidth variant="outlined" type="number" 
                                                value={driverCut}
                                                onChange={(e) => setDriverCut(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid2>
                                    )}

                                    {zoneType==5 && (
                                        <Grid2 item sx={{marginTop:'4%'}}>
                                            <Label>Week days<span style={{ color: 'red' }}>*</span></Label>
                                            
                                            <FormGroup>
                                                <Grid2 item>
                                                    <FormControlLabel control={<Checkbox value={1} checked={weekDaysData?.includes('1')} onChange={handleCheckboxChange} />} label="Monday" />
                                                    <FormControlLabel control={<Checkbox value={2} checked={weekDaysData?.includes('2')} onChange={handleCheckboxChange} />} label="Tuesday" value={2} />
                                                    <FormControlLabel control={<Checkbox value={3} checked={weekDaysData?.includes('3')} onChange={handleCheckboxChange}/>} label="Wednesday" value={3} />
                                                    <FormControlLabel control={<Checkbox value={4} checked={weekDaysData?.includes('4')} onChange={handleCheckboxChange} />} label="Thursday" value={4} />
                                                    <FormControlLabel control={<Checkbox value={5} checked={weekDaysData?.includes('5')} onChange={handleCheckboxChange}/>} label="Friday" value={5} />
                                                    <FormControlLabel control={<Checkbox value={6} checked={weekDaysData?.includes('6')} onChange={handleCheckboxChange} />} label="Saturday" value={6} />
                                                    <FormControlLabel control={<Checkbox value={7} checked={weekDaysData?.includes('7')} onChange={handleCheckboxChange} />} label="Sunday" value={7} />
                                                </Grid2>
                                                
                                            </FormGroup>
                                        </Grid2>
                                    )}

                                    {zoneType==5 && (
                                        <Grid2 container spacing={2}
                                            sx={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', marginTop:'1%'}}
                                        >
                                            <Grid2 item size={6} sx={{ marginTop: '4%'}}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker label="Start Date" value={startDate} onChange={(newValue) => setStartDate(newValue)}
                                                    // minDate={dayjs()}
                                                    renderInput={(params) => (
                                                        <TextField {...params}  fullWidth
                                                            sx={{'& .MuiInputBase-root': { overflow: 'hidden'}}}
                                                        />
                                                    )}
                                                />
                                                </LocalizationProvider>
                                            </Grid2>
    
                                            <Grid2 item size={6} sx={{marginTop: '4%'}}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker value={endDate}
                                                    onChange={(newValue) => setEndDate(newValue)} minDate={startDate}
                                                    renderInput={(params) => (
                                                        <TextField {...params} fullWidth
                                                            sx={{'& .MuiInputBase-root': {overflow: 'hidden'}}}
                                                        />
                                                    )}
                                                />
                                                </LocalizationProvider>
                                            </Grid2>
    
                                            <Grid2 item size={6} sx={{marginTop: '4%'}}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <TimePicker value={startTime}
                                                    onChange={(newValue) => setStartTime(newValue)}
                                                    ampm={false}
                                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                                />
                                                </LocalizationProvider>
                                            </Grid2>
    
                                            <Grid2 item size={6} sx={{marginTop: '4%'}}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <TimePicker value={endTime}
                                                    onChange={(newValue) => setEndTime(newValue)}
                                                    ampm={false}
                                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                                />
                                                </LocalizationProvider>
                                            </Grid2>
                                            </Grid2>
                                    )}

                                    { (constants.customZoneCharge).indexOf(+(zoneType)) !== -1 && (
                                        <Grid2 item sx={{marginTop:'3%', padding:'4px'}}>
                                            <Label>Charge<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Charge" fullWidth variant="outlined" type="number" 
                                                value={rate}
                                                onChange={(e) => setRate(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid2>
                                    )}

                                    {zoneType==4 &&
                                        <Grid2 item sx={{marginTop:'3%', padding:'4px'}}>
                                            <Label>Pickup Geofence<span style={{ color: 'red' }}>*</span></Label>
                                            <Grid2 container spacing={2}>
                                                <Grid2 item sx={{border:(geofenceType=='pickup' && geofencePickup.length === 0)?'1px solid #0DBA78':'1px solid #E3E5E8', borderRadius:'8px', padding:'8px', marginTop:'1%', cursor:geofencePickup.length > 0 ? 'not-allowed' : 'pointer', pointerEvents: geofencePickup.length > 0 ? 'none' : 'auto', opacity: geofencePickup.length > 0 ? 0.5 : 1}}
                                                    onClick={() => {
                                                        if (geofencePickup.length === 0) {
                                                            setGeofenceType('pickup');
                                                            setCustomGeofence([]);
                                                        }
                                                    }}>
                                                    <CreateIcon sx={{color:(geofenceType=='pickup' && geofencePickup.length === 0)?'#0DBA78':'#000'}}/>
                                                </Grid2>

                                                <Grid2 item sx={{border:(geofenceType=='pickup' && geofencePickup.length>0)?'1px solid #0DBA78':'1px solid #E3E5E8', borderRadius:'8px', padding:'8px', marginTop:'1%', cursor:'pointer'}}
                                                    onClick={() => {
                                                        setGeofenceType('pickup');
                                                        setCustomGeofence(geofencePickup);
                                                    }}>
                                                    <VisibilityIcon sx={{color:(geofenceType=='pickup' && geofencePickup.length>0)?'#0DBA78':'#000', cursor:geofencePickup.length == 0 ? 'not-allowed' : 'pointer', pointerEvents: geofencePickup.length == 0 ? 'none' : 'auto', opacity: geofencePickup.length == 0 ? 0.5 : 1}}/>
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>
                                    }

                                    {zoneType==4 &&
                                        <Grid2 item sx={{marginTop:'3%', padding:'4px'}}>
                                            <Label>Drop Geofence<span style={{ color: 'red' }}>*</span></Label>
                                            <Grid2 container spacing={2}>
                                                <Grid2 item sx={{border:(geofenceType=='drop' && geofenceDrop.length === 0)?'1px solid #0DBA78':'1px solid #E3E5E8', borderRadius:'8px', padding:'8px', marginTop:'1%', cursor:geofenceDrop.length > 0 ? 'not-allowed' : 'pointer', pointerEvents: geofenceDrop.length > 0 ? 'none' : 'auto', opacity: geofenceDrop.length > 0 ? 0.5 : 1}}
                                                    onClick={() => {
                                                        if (geofenceDrop.length === 0) {
                                                            setGeofenceType('drop');
                                                            setCustomGeofence([]);
                                                        }
                                                    }}>
                                                    <CreateIcon sx={{color:(geofenceType=='drop' && geofenceDrop.length === 0)?'#0DBA78':'#000'}}/>
                                                </Grid2>

                                                <Grid2 item sx={{border:(geofenceType=='drop' && geofenceDrop.length>0)?'1px solid #0DBA78':'1px solid #E3E5E8', borderRadius:'8px', padding:'8px', marginTop:'1%', cursor:'pointer'}}
                                                    onClick={() => {
                                                        setGeofenceType('drop');
                                                        setCustomGeofence(geofenceDrop);
                                                    }}>
                                                    <VisibilityIcon sx={{color:(geofenceType=='drop' && geofenceDrop.length>0)?'#0DBA78':'#000', cursor:geofenceDrop.length == 0 ? 'not-allowed' : 'pointer', pointerEvents: geofenceDrop.length == 0 ? 'none' : 'auto', opacity: geofenceDrop.length == 0 ? 0.5 : 1}}/>
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>   
                                    }

                                    <Grid2 container item sx={{marginTop:'6%', justifyContent:'center', marginBottom:'4%'}} spacing={4}>
                                        <Grid2 item>
                                            <Button variant="contained" sx={{backgroundColor:'#0065FF'}} onClick={saveData}>{openAddModal ? 'Create' : 'Update'}</Button>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button variant="contained" sx={{backgroundColor:'#D14545'}} onClick={handleClose}>Cancel</Button>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <Grid2 item size={7}>

                                    <CommonGeofence 
                                        key={`geofence-${geofenceType}`}
                                        geofence={customGeofence ? customGeofence : null} 
                                        onUpdatePolygon={handleUpdatePolygon}
                                        zoneType={zoneType}
                                        setNullGeofence={setNullGeofence}
                                        geofenceType={geofenceType}
                                    />
                                    
                                </Grid2>
                            </Grid2>
                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
                
        </div>
    )
}

export default CustomZone;